import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full bg-cream py-16 md:py-24 px-4" data-id="element-80">
      <div className="max-w-7xl mx-auto" data-id="element-81">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-82">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="text-center md:text-left" data-id="element-83">
            <h1 className="font-serif text-5xl md:text-7xl font-bold text-terracotta mb-4" data-id="element-84">
              Menopausia Activa
            </h1>
            <p className="font-serif text-3xl md:text-4xl text-sage mb-6" data-id="element-85">
              El Protocolo de Proteína y Pesas
            </p>
            <p className="text-xl md:text-2xl text-brown mb-8 leading-relaxed" data-id="element-86">
              Recupera tu metabolismo, tu fuerza y tu energía con el método
              30-30-3
            </p>

            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} onClick={() => document.getElementById('precio')?.scrollIntoView({
            behavior: 'smooth'
          })} className="bg-terracotta text-cream px-8 py-4 rounded-lg text-xl font-semibold shadow-lg hover:shadow-xl transition-shadow mb-4" data-id="element-87">
              ¡Quiero Mi Copia Ahora!
            </motion.button>

            <p className="text-sm text-brown/70" data-id="element-88">
              Descarga inmediata • Formato PDF • Garantía de 30 días
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          rotateY: -15
        }} animate={{
          opacity: 1,
          scale: 1,
          rotateY: 0
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="flex justify-center" data-id="element-89">
            <div className="relative" data-id="element-90">
              <div className="absolute inset-0 bg-terracotta/20 blur-3xl rounded-full transform translate-y-8" data-id="element-91"></div>
              <img src="https://cdn.magicpatterns.com/uploads/5NHTK9Fq1vn5LGEjN9V3v8/menop.png" alt="Menopausia Activa Book Cover" className="relative w-full max-w-md transform rotate-3 hover:rotate-0 transition-transform duration-500 shadow-2xl rounded-lg" data-id="element-92" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}